// extracted by mini-css-extract-plugin
export default {"wrapper":"xD-z","viewport":"yD-z","container":"zD-z","slide":"AD-z"};